import { useEffect, useState } from "react";
import { useDispatch } from "react-redux"
import { generalOpenToastError } from "../../../../actions/general.actions";
import InputForm from "../../../OtrosDocumentos/Components/InputFormV2";
import { getDataLibrosGenerados, setFormConsultaLibros } from "../../../../actions/libros/libros-ventas.actions";
import BasicCardDocumentos from "../DatosDeCierre/BasicCardDocumentos";
import { optionsLibroVentas } from "../LibroVentas/FormularioLibroVentas";

export default function FormularioBuscarLibros (){
    const dispatch = useDispatch()

    const defaultValue = {startDate: '', endDate: '', tipoLibro: ''}
    const [data, setData] = useState(defaultValue);
    const [errors, setErrors] = useState(defaultValue)
  
    const onChangeHandler = async (e: any) => {
      let {name, value} = e.target;
      const errorMessage = HandleValidationError(e);
      setData(prevData => ({
        ...prevData,
        [name]: value
      }));
      setErrors(prevData => ({
        ...prevData,
        [name]: errorMessage
      })); 
    }

    const handleOpenWarning = async () => {
      if (!validarVacios()) return;
      if (!validationData(data, errors)) return;
      dispatch(getDataLibrosGenerados(data));
      dispatch(setFormConsultaLibros(data));
    }

    const validarVacios = () => {
        if (data?.startDate === ''){
            dispatch(generalOpenToastError('La fecha inicial no puede estar vacía'));
            setErrors(prevData => ({...prevData, startDate: 'La fecha inicial no puede estar vacía'}));
            return false;
        }
        if (data?.endDate === ''){
            dispatch(generalOpenToastError('La fecha final no puede estar vacía'));
            setErrors(prevData => ({...prevData, endDate: 'La fecha final no puede estar vacía'}));
            return false;
        }
        if (data?.tipoLibro === ''){
          dispatch(generalOpenToastError('El tipo de libro no puede estar vacío'));
          setErrors(prevData => ({...prevData, tipoLibro: 'El tipo de libro no puede estar vacío'}));
          return false;
      }
        return true;
    }

    const validationData = (data: any, errors: any) => {
      for (let err of Object.values(errors)) {
        if (err !== '') {
          dispatch(generalOpenToastError('Los datos de cierre contienen valores incorrectos'));
          return false;
        }
      }
      if (!fechaMayor(data?.endDate, data?.startDate)){
        dispatch(generalOpenToastError('La fecha final debe ser mayor a la fecha inicial'));
        return false;
      }
      return true;
    }

    const fechaMayor = (fecha1: string, fecha2: string) => {
        const fecha1Obj = new Date(fecha1);
        const fecha2Obj = new Date(fecha2);
        if (fecha1Obj >= fecha2Obj) return true;
        return false
    }

    const HandleValidationError = (e: any) => {
        let {name, value} = e.target
        let message = ''
        switch (name) {
          case 'startDate':
            const startDate = new Date(value);
            if (isNaN(startDate.getTime())) {
              message = 'La fecha contiene valores incorrectos'
            }
            break;
          case 'endDate':
            const endDate = new Date(value);
            if (isNaN(endDate.getTime())) {
              message = 'La fecha contiene valores incorrectos'
            }
            break;
          default:
            break;
        }
        return message;
    }

    return (
      <div className="w-layout-layout bill-section wf-layout-layout">
        <BasicCardDocumentos style={{boxShadow: 'none', padding: '0'}} title="Detalle de libros generados" size="l">
          <div>
            <div className='w-layout-hflex h-inputs'>
              <InputForm required name = 'startDate' label = 'Fecha inicial' type = 'date' onChange={onChangeHandler} error={errors.startDate} value={data.startDate}/>
              <InputForm required name = 'endDate' label = 'Fecha final' type = 'date' onChange={onChangeHandler} error={errors.endDate} value={data.endDate} />
              <InputForm
                onChange = {(e: any) => onChangeHandler({target: {value: e.value, name: 'tipoLibro'}})} value={data.tipoLibro} error={errors.tipoLibro}
                required keyNameText = 'codigo_nombre' keyNameValue = 'codigo' name = 'tipoLibro' placeholder = 'Seleccione una opcion' label = 'Tipo Libro' type = 'select'
                options = {optionsLibroVentas} />
            </div>
            <div style={{width: '100%', display: 'flex', gap: '16px'}}>
              <div style={{display: 'flex', justifyContent: 'end', alignItems: 'end', marginTop: '16px', width: '100%'}}>
                <button className="button w-auto" onClick={handleOpenWarning}>Buscar</button>
              </div>
            </div>
          </div>
        </BasicCardDocumentos>
      </div>
    );
}